var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "metadata"
  }, [_c('div', [_c('div', {
    staticClass: "meta_data"
  }, [_c('article', [_c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Blockchains "), _c('TooltipMeta', {
    attrs: {
      "content": "Total number of blockchains created on this subnetwork"
    }
  })], 1), _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.totalBlockchains.toLocaleString('en-US')) + " ")])])]), _c('article', [_c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Validators "), _c('TooltipMeta', {
    attrs: {
      "content": "Total number of nodes participating in the consensus protocol of this subnetwork"
    }
  })], 1), _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.totalValidators.toLocaleString('en-US')) + " ")])])]), _c('article', [_c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Delegations "), _c('TooltipMeta', {
    attrs: {
      "content": "Total number of stake delegations to validators"
    }
  })], 1), _c('p', {
    staticClass: "meta_val"
  }, [_vm.totalDelegators ? [_vm._v(" " + _vm._s(_vm.totalDelegators.toLocaleString('en-US')) + " ")] : [_vm._v("n/a")]], 2)])]), _c('article', [_c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Control Keys "), _c('TooltipMeta', {
    attrs: {
      "content": "In order to add a validator to a subnet, threshold signatures from keys are needed"
    }
  })], 1), _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.totalControlKeys.toLocaleString('en-US')) + " ")])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }